import type { ExternalResourceInvokeSubject } from '../../store/types'
import { LabelRow } from './LabelRow'
import './ToolInput.css'

// Body renderer for permission_request frames with
// subject_kind=external_resource_invoke. Sibling to ToolInput.
// Future subject kinds (agent_spawn, rule_proposal, ...) plug in
// alongside this one — they all share the surrounding card chrome
// (header / countdown / approve-deny buttons / always-allow menu).
//
// args is rendered as pretty-printed JSON for now. Per-plugin
// renderers (e.g. ha.turn_on showing entity_id + brightness) are a
// phase-2 concern when the mobile rule editor ships and plugins
// can ship their own renderer hints in the manifest.
export function ExternalResourceInvokeBody({
  subject,
}: {
  subject: ExternalResourceInvokeSubject
}) {
  const args = subject.args
  const principalLabel =
    subject.principal_kind === 'agent'
      ? 'requested by agent'
      : 'requested by you'

  return (
    <div className="tool-input">
      <LabelRow label="Plugin" copy={subject.plugin_slug} />
      <code className="tool-input__mono">{subject.plugin_slug}</code>
      <LabelRow label="Verb" copy={subject.verb} />
      <code className="tool-input__mono">{subject.verb}</code>
      <LabelRow label="Connection" copy={subject.connection_id} />
      <code className="tool-input__mono">{subject.connection_id}</code>
      {/* Caller is a rendered sentence, not a value you'd paste anywhere. */}
      <LabelRow label="Caller" />
      <div className="tool-input__text">{principalLabel}</div>
      {args && Object.keys(args).length > 0 && (
        <>
          <LabelRow label="Args" copy={JSON.stringify(args, null, 2)} />
          <pre className="tool-input__mono tool-input__mono--block">
            {JSON.stringify(args, null, 2)}
          </pre>
        </>
      )}
    </div>
  )
}
